import { render, staticRenderFns } from "./trends.vue?vue&type=template&id=8958a834&scoped=true&"
import script from "./trends.vue?vue&type=script&lang=js&"
export * from "./trends.vue?vue&type=script&lang=js&"
import style0 from "./trends.vue?vue&type=style&index=0&id=8958a834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8958a834",
  null
  
)

export default component.exports